import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE = 'https://pinballscoresapp-ayd8babtd4fpadec.eastus2-01.azurewebsites.net/api';

export default function EditTables({ isAdmin }) {
  const [tables, setTables] = useState([]);
  const [selectedTableId, setSelectedTableId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    type: '',
    year: '',
    summary: '',
    logo: ''
  });

  useEffect(() => {
    axios.get(`${API_BASE}/tables`).then((res) => {
      setTables(res.data);
    });
  }, []);

  useEffect(() => {
    if (selectedTableId) {
      const table = tables.find((t) => t.TableID === parseInt(selectedTableId));
      if (table) {
        setFormData({
          name: table.Name || '',
          type: table.Type || '',
          year: table.Year || '',
          summary: table.Summary || '',
          logo: table.LogoUrl || table.Logo || ''
        });
      }
    }
  }, [selectedTableId, tables]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    axios.put(`${API_BASE}/tables/${selectedTableId}`, formData)
      .then(() => alert('Table updated successfully'))
      .catch((err) => alert('Error updating table'));
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this table?')) {
      axios.delete(`${API_BASE}/tables/${selectedTableId}`)
        .then(() => {
          alert('Table deleted');
          setSelectedTableId(null);
          setFormData({ name: '', type: '', year: '', summary: '', logo: '' });
          axios.get(`${API_BASE}/tables`).then((res) => {
            setTables(res.data);
          });
        })
        .catch((err) => alert('Error deleting table'));
    }
  };

  const handleAddTable = () => {
    axios.post(`${API_BASE}/tables`, formData)
      .then(() => {
        alert('Table added');
        setFormData({ name: '', type: '', year: '', summary: '', logo: '' });
        axios.get(`${API_BASE}/tables`).then((res) => {
          setTables(res.data);
        });
      })
      .catch((err) => alert('Error adding table'));
  };

  if (!isAdmin) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>You must be authenticated as an admin to view this page.</p>
        <a href="/?admin">Go to Home & Log In</a>
      </div>
    );
  }

  return (
    <div className="edit-tables" style={{ fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <h2 style={{ fontFamily: "'DotMatrix', sans-serif" }}>Edit Tables</h2>

      <label style={{ fontWeight: 600 }}>Select Table:</label>
      <select value={selectedTableId || ''} onChange={(e) => setSelectedTableId(e.target.value)} style={{ fontFamily: 'inherit' }}>
        <option value="">-- Select a table --</option>
        {tables.map((table) => (
          <option key={table.TableID} value={table.TableID}>
            {table.Name} ({table.Type})
          </option>
        ))}
      </select>

      <div className="table-form">
        <label>Name:</label>
        <input name="name" value={formData.name} onChange={handleChange} style={{ fontFamily: 'inherit' }} />

        <label>Type:</label>
        <input name="type" value={formData.type} onChange={handleChange} style={{ fontFamily: 'inherit' }} />

        <label>Year:</label>
        <input name="year" value={formData.year} onChange={handleChange} style={{ fontFamily: 'inherit' }} />

        <label>Summary:</label>
        <textarea name="summary" value={formData.summary} onChange={handleChange} style={{ fontFamily: 'inherit' }} />

        <label>Logo URL:</label>
        <input name="logo" value={formData.logo} onChange={handleChange} style={{ fontFamily: 'inherit' }} />

        {selectedTableId ? (
          <div style={{ marginTop: '12px' }}>
            <button onClick={handleSave}>Save Changes</button>
            <button onClick={handleDelete} style={{ marginLeft: '10px', backgroundColor: '#c0392b' }}>Delete Table</button>
          </div>
        ) : (
          <button onClick={handleAddTable} style={{ marginTop: '12px' }}>Add Table</button>
        )}
      </div>
    </div>
  );
}